import {downloadCSVFiles} from '@/helpers/shadcn/utils'
import {getInventoryFileUploadErrors, getInventoryUploadHistory} from '@/services/ProductsService/Fulfillment/inventory'
import {DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import {useQuery} from '@tanstack/react-query'
import {useMemo, useState} from 'react'

export const INVENTORY_UPLOAD_HISTORY_KEY = 'INVENTORY_UPLOAD_HISTORY'

const useUploadHistory = type => {
  const [uploadHistoryPageIndex, setUploadHistoryPageIndex] = useState(0)

  const uploadHistoryQueryParams = useMemo(() => {
    const params = new URLSearchParams()
    params.append('sort', 'createdDateTime,desc')
    params.append('page', uploadHistoryPageIndex)
    params.append('pageSize', DEFAULT_TABLE_PAGE_SIZE)
    return params.toString()
  }, [uploadHistoryPageIndex])

  const uploadHistoryResult = useQuery({
    queryKey: [INVENTORY_UPLOAD_HISTORY_KEY, type, uploadHistoryQueryParams],
    queryFn: () => getInventoryUploadHistory(type, uploadHistoryQueryParams),
  })

  const uploadHistory = uploadHistoryResult?.data

  const getErrorTemplateFilename = () => {
    const date = new Date()
    const timestamp = date.toISOString().replace(/[-:]/g, '').replace('T', '_').split('.')[0]
    return `Upload_Error_Template_${timestamp}`
  }

  const downloadUploadError = async parentId => {
    const response = await getInventoryFileUploadErrors(parentId, 'text/csv')
    await downloadCSVFiles(response, getErrorTemplateFilename())
  }

  return {
    onUploadHistoryPageIndexChange: setUploadHistoryPageIndex,
    uploadHistoryData: uploadHistory || [],
    downloadUploadError,
  }
}

export default useUploadHistory
